import {NotificationData} from "@/types";
import {GetterTree} from "vuex";
import { NotificationsAdminzoneState } from "@/types/store/adminzone/notification";
import { RootState } from "@/types/store/adminzone";

export const getters: GetterTree<NotificationsAdminzoneState, RootState> = {
  GET_NOTIFICATIONS: (state): Array<NotificationData> => state.notifications,
 }
